/**
 * PinIndicator — small header badge showing active pin count.
 * Self-hides when count is 0. Clickable → triggers onClick (e.g. open
 * a drawer or scroll to the Pull-the-pin section).
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { Pin } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PinIndicator({ onClick, className = "" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/pins/me`, {
          withCredentials: true,
        });
        if (!cancelled) setCount(data?.count || 0);
      } catch {
        /* silent */
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (count === 0) return null;

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="pin-indicator"
      className={`relative inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl bg-indigo-50 dark:bg-indigo-900/30 border border-indigo-200 dark:border-indigo-800 text-indigo-700 dark:text-indigo-300 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors ${className}`}
      title={`${count} pin${count === 1 ? "" : "s"} active`}
    >
      <Pin className="w-3.5 h-3.5" />
      <span className="text-xs font-bold">{count}</span>
    </button>
  );
}
